import React from 'react';
import PropTypes from 'prop-types';
import Button from 'wonderbly-components/lib/Button';
import Select from 'wonderbly-components/lib/Select';
import InlineLabel from 'wonderbly-components/lib/InlineLabel';

const ShippingAddress = props => (
  <div className="shipping-address">
    <h3>{props.header}</h3>
    {props.shipping && (
      <React.Fragment>
        {props.isEditing ? (
          <form onSubmit={props.handleSubmit} className="shipping-address-form">
            <InlineLabel htmlFor="firstName">{props.firstName}</InlineLabel>
            <input type="text" id="firstName" value={props.values.firstName} onChange={props.handleChange} />
            <InlineLabel htmlFor="lastName">{props.lastName}</InlineLabel>
            <input type="text" id="lastName" value={props.values.lastName} onChange={props.handleChange} />
            <InlineLabel htmlFor="address1">{props.address1}</InlineLabel>
            <input type="text" id="address1" value={props.values.address1} onChange={props.handleChange} />
            <InlineLabel htmlFor="address2">{props.address2}</InlineLabel>
            <input type="text" id="address2" value={props.values.address2} onChange={props.handleChange} />
            <InlineLabel htmlFor="city">{props.city}</InlineLabel>
            <input type="text" id="city" value={props.values.city} onChange={props.handleChange} />
            {props.states.length > 0 && (
              <React.Fragment>
                <InlineLabel htmlFor="stateAbbr">{props.stateAbbr}</InlineLabel>
                <Select
                  options={props.states}
                  id="stateAbbr"
                  value={props.values.stateAbbr}
                  onChange={props.handleChange}
                />
              </React.Fragment>
            )}
            <InlineLabel htmlFor="zipcode">{props.zipcode}</InlineLabel>
            <input type="text" id="zipcode" value={props.values.zipcode} onChange={props.handleChange} label="Post Code" />
            <InlineLabel htmlFor="country">{props.country}</InlineLabel>
            <Select
              options={[{ label: props.shipping.country, value: props.shipping.country }]}
              id="stateAbbr"
              value={props.shipping.country}
              disabled
            />
            <Button disabled={!props.shipping}>{props.saveChanges}</Button>
          </form>
        ) : (
          <p>
            <span className="address-line">
              {`${props.shipping.firstName} ${props.shipping.lastName}`}
            </span>
            {props.shipping.fullAddress
              .split(',')
              .map((string, i) => <span className="address-line" key={i}>{string}</span>)}
            {props.isEditable && (
              <Button onClick={props.onToggleEdit} disabled={!props.shipping}>{props.editAddress}</Button>
            )}
          </p>
        )}
      </React.Fragment>
    )}
  </div>
);

const valuesProps = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  address1: PropTypes.string.isRequired,
  address2: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  stateAbbr: PropTypes.string.isRequired,
  zipcode: PropTypes.string.isRequired,
  country: PropTypes.string,
};

ShippingAddress.propTypes = {
  header: PropTypes.string.isRequired,
  shipping: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    fullAddress: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
  }),
  states: PropTypes.array,
  isEditing: PropTypes.bool.isRequired,
  isEditable: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onToggleEdit: PropTypes.func.isRequired,
  values: PropTypes.shape(valuesProps),
  saveChanges: PropTypes.string.isRequired,
  editAddress: PropTypes.string.isRequired,
  ...valuesProps,
};

export default ShippingAddress;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/ShippingAddress/ShippingAddress.js